import React, { useState, useEffect } from 'react';
import axios from 'axios'
import Select from 'react-select';
import './form.css';
import { toast } from 'react-toastify';
import { AddRevenue } from '../../Redux/action/revenueAction';


import { allLocationWithShortName, dataUser, spocLocationDetailsZoho } from '../Helpers/util';
import { getLocationNameById } from '../../utils/getLocationNameById';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';

import dayjs from "dayjs";
import AntDTimePicker from '../Common/AntDDateTimePicker/AntDTimePicker';

let count = 0;

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName()
class ExtendedWorking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pax: null,
      location: '',
      locationError: '',
      paxError: '',
      dateError: '',
      location1: '',
      locationData: [],
      locationNew: [],
      locationId: null,
      pax1: null,
      purpose: '',
      notes: '',
      budget: '',
      company_id: UserObj ? UserObj.company_id : null,
      userid: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : null,
      fb: '',
      date: '',
      switchOnTimeError: '',
      switchOffTimeError: '',
      switchOnTime: '',
      switchOffTime: '',
      acDate: '',
      files: null,
      attachmentError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      dynamicFieldError: false,

      value: '',

      func: [
        {
          date: '',
          switchOnTime: '',
          switchOffTime: '',
          minEndTime: '', // Added for dynamic end time disabling
        },
      ],
    };
  }

  onPaxChange = e => {
    this.setState({
      pax: e?.target?.value,
      paxError: null
    });
  };


  changeSelect = (e) => {
    if (!e) {
      this.setState({
        location: null,
        location1: "",
        locationId: "",
        locationError: "",
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: "",
    });
  };




  onNotes = e => {
    this.setState({
      notes: e?.target?.value,
      noteError: ''
    });
  };


  componentDidMount() {
    var LocationSpoc = JSON.parse(userDataLocal12);
    let locationShort = JSON.parse(locationWithShortName)
    this.setState({ locationNew: locationShort })
    this.setState({
      locationData: LocationSpoc,
    });
  }



  onDateChange = (e, i) => {
    let tempState = [...this.state.func];
    tempState[i]['date'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };

  onStartTimeChange = (time, timeString, i) => {
    let tempState = [...this.state.func];

    tempState[i] = {
      ...tempState[i],
      switchOnTime: time,        // dayjs object
      switchOffTime: null,       // reset end time
      minEndTime: time,          // for disabling earlier end times
    };

    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };



  onEndTimeChange = (time, timeString, i) => {
    const { switchOnTime } = this.state.func[i];

    if (!switchOnTime) {
      toast.error("Please select Start Time first");
      return;
    }

    if (time.isBefore(switchOnTime)) {
      toast.error("End Time cannot be earlier than Start Time");
      return;
    }

    let tempState = [...this.state.func];
    tempState[i].switchOffTime = time;

    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };


  disabledEndTime = (index) => {
    const startTime = this.state.func[index].switchOnTime;

    if (!startTime) return {};

    return {
      disabledHours: () => {
        const hours = [];
        for (let i = 0; i < startTime.hour(); i++) {
          hours.push(i);
        }
        return hours;
      },
      disabledMinutes: (selectedHour) => {
        if (selectedHour === startTime.hour()) {
          const minutes = [];
          for (let i = 0; i < startTime.minute(); i++) {
            minutes.push(i);
          }
          return minutes;
        }
        return [];
      },
    };
  };



  handleFile(e) {

    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    // Getting the files from the input
    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    }
    else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: "" });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    let files = this.state.files;
    let formData = new FormData();

    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }

    let dynamicFieldError = false;
    let endTimeError = false;

    // Check if all required fields are filled
    this.state.func.forEach(item => {
      if (!(item.date && item.switchOffTime && item.switchOnTime)) {
        dynamicFieldError = true;
      }

      // Validate end time against start time
      if (item.switchOnTime && item.switchOffTime && item.switchOffTime < item.switchOnTime) {
        endTimeError = true;
      }
    });

    if (this.state.location === null || this.state.location === '') {
      this.setState({ locationError: "Location can't be empty" });
    } else if (dynamicFieldError) {
      this.setState({ dynamicFieldError: true });
    } else if (endTimeError) {
      toast.error("End Time cannot be earlier than Start Time.");
    } else if (this.state.files != null && this.state.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else {
      e.currentTarget.disabled = true;

      // Exclude minEndTime from func array
      // const funcWithoutMinEndTime = this.state.func.map(({ minEndTime, ...rest }) => rest);
      const funcWithoutMinEndTime = this.state.func.map(
        ({ minEndTime, switchOnTime, switchOffTime, ...rest }) => ({
          ...rest,
          switchOnTime: switchOnTime ? switchOnTime.format("HH:mm") : "",
          switchOffTime: switchOffTime ? switchOffTime.format("HH:mm") : "",
        })
      );


      let param = {};
      let common_param = {
        company_id: this.state.company_id,
        spoc_id: this.state.userid,
        email: this.state.email,
        category: 'ext_working_hours',
        company_name: UserObj ? UserObj.company_name : null,
      };
      let body_param = {
        extention_date_obj: funcWithoutMinEndTime, // Use the modified func array
        notes: this.state.notes,
        location_name: this.state.location1,
      };
      param.common_param = common_param;
      param.body_param = body_param;
      //   AddRevenue(param, formData);

      //   this.setState({
      //     btnStatus: false,
      //   });
      //   e.currentTarget.disabled = false
      // }
      AddRevenue(param, (success, message) => {
        if (success) {
          toast.success(message);
          this.resetValue();
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
        this.setState({ btnStatus: false });
        e.currentTarget.disabled = false;
      });
    }
  };


  resetValue = () => {
    this.setState({
      date: '',
      notes: '',
      location: '',
      pax: '',
      locationError: '',
      paxError: '',
      dateError: '',
      switchOnTimeError: '',
      switchOffTimeError: '',
      switchOnTime: '',
      switchOffTime: '',
      acDate: '',
      func: [
        {
          date: '',
          switchOnTime: null,
          switchOffTime: null,
          minEndTime: null,
        },
      ],
    });
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    })
  };


  removeFormFields(i) {
    let formValues = this.state.func;
    formValues.splice(i, 1);
    this.setState({ formValues });
  }

  render() {
    return (
      <>

        <div className="row">
          <div className="col-md-12 ">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Location <span className="Required">*</span></label>
              <SwSelect
                name="location"
                id="extended-location-select"
                onChange={this.changeSelect}
                value={this.state.location}
                options={this.state.locationData}
                isClearable={false}
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.locationError}
              </span>
            </div>
          </div>
        </div>

        {this.state.func.map((item, index) => {
          return (<div className="row ExtendedWork_form_row">
            <div className='col-md-12'>
              <div className="SwFormGroup">
                <label className="SwFormLabel">
                  Date of extension <span className="Required">*</span>
                </label>

                <AntDDatePicker
                  type="single"
                  allowClear={false}
                  format="DD/MM/YYYY"
                  value={item.date ? dayjs(item.date) : null}
                  disabledDate={(current) =>
                    current && current < dayjs().startOf("day")
                  }
                  onChange={(date) => {
                    this.onDateChange(
                      {
                        target: {
                          name: "date",
                          value: date ? date.format("YYYY-MM-DD") : ""
                        }
                      },
                      index
                    );
                  }}
                />

                {this.state.dynamicFieldError && !item.date && (
                  <span className="SwTextDanger SwTextSmall">
                    {"Date can't be Empty"}
                  </span>
                )}
              </div>

            </div>
            <div className="col-md-6 pr-2">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Start Time <span className="Required">*</span></label>
                <AntDTimePicker
                  name="switchOnTime"
                  value={item.switchOnTime}
                  onChange={(time, timeString) =>
                    this.onStartTimeChange(time, timeString, index)
                  }
                  format="HH:mm"
                  placeholder="Start Time"
                  allowClear={false}
                />
                {this.state.dynamicFieldError && !item.switchOnTime && (
                  <span className="SwTextDanger SwTextSmall">tart Time can't be empty</span>
                )}
              </div>
            </div>
            <div className="col-md-6 pl-2">
              <div className="SwFormGroup">
                <label className="SwFormLabel">End Time <span className="Required">*</span></label>
                <AntDTimePicker
                  name="switchOffTime"
                  value={item.switchOffTime}
                  onChange={(time, timeString) =>
                    this.onEndTimeChange(time, timeString, index)
                  }
                  format="HH:mm"
                  placeholder="End Time"
                  allowClear={false}
                  disabledTime={() => this.disabledEndTime(index)}
                />

                {this.state.dynamicFieldError && !item.switchOffTime && (
                  <span className="SwTextDanger SwTextSmall">nd Time can't be empty</span>
                )}
              </div>
            </div>

            <div className=''>
              {index == 0 ? (
                <div >
                  {' '}
                  <button
                    type="button"
                    className="pl-0 btn addMoreIcon flex"
                    onClick={() => {
                      let tempState = [...this.state.func];
                      tempState.push({
                        date: '',
                        switchOnTime: '',
                        switchOffTime: '',
                      });
                      this.setState({
                        func: tempState,
                      });
                      {
                        count = count + 1;
                      }
                    }}
                  >
                    {' '}
                    <span>
                      {' '}
                      <i
                        className="fa fa-plus-circle"
                        aria-hidden="true"
                      />{' '}
                      Add More
                    </span>{' '}
                  </button>{' '}
                </div>
              ) : (
                <div className="">
                  {' '}
                  <button
                    type="button"
                    className="btn removeBtn1 pt-1"
                    onClick={() => {
                      this.removeFormFields(index);
                      {
                        count = count - 1;
                      }
                    }}
                  >
                    {' '}
                    <span>
                      {' '}
                      <i
                        className="fa fa-trash"
                        aria-hidden="true"
                      />{' '}
                    </span>{' '}
                  </button>{' '}
                </div>
              )}
            </div>

          </div>
          );
        })}

        <div className="row">
          <div className="col-md-12 col-xl-12 col-lg-12 mt-3">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Notes</label>
              <SwTextArea
                rows="4"
                value={this.state.notes}
                onChange={this.onNotes}
                id="extended-working-notes"
              />

            </div>
          </div >
        </div >

      </>
    );
  }
}

export default ExtendedWorking;
